/**
 * English-only title keywords for the meeting notes automation discovery nudge.
 *
 * Title only: the body-content keywords were removed because matching them
 * against the page body fired on far too many pages.
 *
 * Forked from `@confluence/experiment-meeting-signal-core`, which defines the
 * same keywords with `defineMessages` so they can be localized. That package is
 * shared with the Loom meeting-signal experiment (and `content-renderer` /
 * `editor-features`), so it keeps its localized catalogues and is deliberately
 * left untouched.
 *
 * The nudge is English-only: it opens an English Rovo conversation that builds
 * an English automation rule, so a localized trigger would surface a nudge whose
 * entire downstream experience is still English. These are matching inputs, not
 * user-facing copy, so they are plain constants and are not extracted for
 * translation.
 *
 * Matched whole-word and case-insensitively - see `matchMeetingSignal`. Frozen
 * so the compiled-regex cache in `matchMeetingSignal` (keyed on array identity)
 * stays warm across renders.
 */

export const MEETING_NOTES_TITLE_KEYWORDS: readonly string[] = Object.freeze([
	'meeting',
	'meetings',
	'sync',
	'standup',
	'daily standup',
	'huddle',
	'check-in',
	'1:1',
	'kickoff',
	'review',
	'demo',
	'showcase',
	'working session',
	'office hours',
	'town hall',
	'all hands',
	'leadership sync',
	'staff meeting',
	'team meeting',
	'customer call',
	'discovery call',
	'design review',
	'architecture review',
	'backlog refinement',
	'agenda',
	'meeting agenda',
	'meeting notes',
	'discussion topics',
	'discussion',
	'decisions',
	'decision log',
	'attendees',
	'participants',
	'outcomes',
	'parking lot',
]);
